import { EditorFeatureTransformTranslate } from "./editor-feature-transform-translate";
import { Feature } from "geojson";
import { TransformInteractionState } from "../abstract-transform";

export class EditorClone extends EditorFeatureTransformTranslate {
  save(state: TransformInteractionState, nextInteraction: string | undefined = undefined) {
    this.createLayerGeometries([{
      type: 'Feature',
      properties: state.features.get(state.featureID).properties,
      geometry: (this.transformedFeature.toGeoJSON() as Feature).geometry
    }]);
  }
}
